import Vue from 'vue'
import ssAxios from './SSAxios'

const self = Vue.prototype

export default {

    /**
     * Logging ssUser by phone
     * @returns {Promise<any>}
     * @param phone {string}
     * @param token {string}
     * @param hash {string}
     */
    ssLogin(phone, token, hash) {
        return new Promise((resolve, reject) => {
            ssAxios.httpClient.post(
                self.$apiRouter.ssLogin,
                {
                    phone: phone,
                    "g-recaptcha-token": token,
                    hash: hash,
                }
            )
                .then(response => {
                    resolve(response)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    },

    /**
     * Verify phone
     * @returns {Promise<any>}
     * @param phone {string}
     * @param code {string}
     */
    ssVerify(phone, code) {
        return new Promise((resolve, reject) => {
            ssAxios.httpClient.post(
                self.$apiRouter.ssVerify,
                {phone: phone, code: code}
            )
                .then(response => {
                    resolve(response)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    },

    /**
     * Resend code
     * @returns {Promise<any>}
     * @param phone {string}
     * @param token {string}
     */
    ssResend(phone, token) {
        return new Promise((resolve, reject) => {
            ssAxios.httpClient.post(
                self.$apiRouter.ssLogin,
                {phone: phone, "g-recaptcha-token": token}
            )
                .then(response => {
                    resolve(response)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    },

    /**
     * Logout user
     * @returns {Promise<any>}
     */
    logout() {
        return new Promise((resolve, reject) => {
            ssAxios.httpClient.post(self.$apiRouter.ssLogout)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },

}
